import { KPI_VALUE_CLASSIC } from '@/utils/hooks/format/useFormatKpiValue';

import { colors } from '@/lib/analytics/colors';
import type { KpiType } from '@/lib/analytics/kpis/kpi.type';
import { ORIENTATION_VERTICAL } from '@/lib/gridElements/orientation';
import { SIZE_25 } from '@/lib/gridElements/size';

import { KPIDefault } from '@/components/base/Kpi/KpiDefault';
import { DefaultLoader } from '@/components/base/Kpi/KpiLoader';

export const totalCommentsConfig: KpiType<typeof DefaultLoader, typeof KPIDefault> = {
    name: 'kpi.pinterest.total_comments_received',
    tooltip: 'kpi.pinterest.tooltip_total_comments_received',
    id: 'comments',
    icon: {
        name: 'comments-on',
        style: colors.yellow
    },
    growth_tooltip: {
        up: 'analytics:kpi.growth_tooltip.up',
        down: 'analytics:kpi.growth_tooltip.down',
        still: 'analytics:kpi.growth_tooltip.still'
    },
    data_format: KPI_VALUE_CLASSIC,
    orientation: ORIENTATION_VERTICAL,
    size: SIZE_25,
    type: 'kpi',
    element: KPIDefault,
    loader: DefaultLoader
};
